import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { URLSearchParams } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Customer } from '../../models/customer';
import { ENV } from '../../environments/environment';

@Injectable()
export class CustomersService {
  private resourceEndpoint: string;
  public Customer: Customer;

  camelToSnake(subjVal) {
    var subjectString = subjVal.toString(),
        separator = "_";

    return subjectString.replace(/[A-Z]/g, function(letter, pos) {
            return (pos ? separator : "") + letter.toLowerCase();
    });
  }

  all(): Observable<Customer[]> {
    return this.http.get<any>(this.resourceEndpoint)
      .map(response => response.data);
  }

  getCustomerByQrCode(qrCode): Observable<any> {
    let queryParams = new URLSearchParams();
    queryParams.set("qr_code",qrCode);
    return this.http.get<any>(`${this.resourceEndpoint}/?` + queryParams.toString())
      .map(response => response.data);
  }

  getById(id, requestParams): Observable<any> {
    requestParams = typeof requestParams === "object" ? requestParams : {};

    let queryParams = new URLSearchParams();

    for(let key in requestParams)
    {
      queryParams.set(key, requestParams[key]);
    }

    return this.http.get<any>(`${this.resourceEndpoint}/${id}?` + queryParams.toString())
      .map(response => response.data);
  }

  search(searchParams: object): Observable<any[]> {
    let queryParams = new URLSearchParams();

    for(let key in searchParams)
    {
      queryParams.set(key, searchParams[key]);
    }

    return this.http.get<any>(`${this.resourceEndpoint}?` + queryParams.toString())
      .map(response => response.data);
  }

  update(id, updateParams): Observable<any> {

    // make sure all 3 payloads are in snake case.
    let u: string;
    if(updateParams.hasOwnProperty("profile"))
    {
      let profile: any = {};
      for(u in updateParams.profile){ profile[this.camelToSnake(u)] = updateParams.profile[u]; }
      updateParams.profile = profile;
    }
    if(updateParams.hasOwnProperty("vehicle"))
    {
      let vehicle: any = {};
      for(u in updateParams.vehicle){ vehicle[this.camelToSnake(u)] = updateParams.vehicle[u]; }
      updateParams.vehicle = vehicle;
    }
    if(updateParams.hasOwnProperty("billing"))
    {
      let billing: any = {};
      for(u in updateParams.billing){ billing[this.camelToSnake(u)] = updateParams.billing[u]; }
      updateParams.billing = billing;
    }
    if(updateParams.hasOwnProperty("status"))
    {
      let status: any = {};
      for(u in updateParams.status){ status[this.camelToSnake(u)] = updateParams.status[u]; }
      updateParams.status = status;
    }

    return this.http.put<any>(`${ENV.apiUrl}/v${ENV.apiVersion}/subscriptions/${id}`,updateParams)
      .map(response => response.data);
  }

  set(Model) {
    this.Customer = Model;
  }

  get() {
    return this.Customer;
  }

  constructor(public http: HttpClient) {
    this.resourceEndpoint = `${ENV.apiUrl}/v${ENV.apiVersion}/integrations/zoho/contacts`;
  }
}



// WEBPACK FOOTER //
// ./src/services/customers/customers-service.ts